import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SvgAtlasComponent } from '@bioreferencehealth/ui-kit';

@Component({
  standalone: true,
  templateUrl: './login-layout.component.html',
  imports: [RouterOutlet, SvgAtlasComponent],
  styleUrls: ['./login-layout.component.scss']
})
export class LoginLayoutComponent {}
